if (!customElements.get('card-product-alt')) {
  customElements.define(
    'card-product-alt',
    class CardProductAlt extends HTMLElement {
      connectedCallback () {
        this.addEventListener('change', this.onOptionChange.bind(this));

        this.submitButton = this.querySelector('.js-submit')
        this.submitCheckbox = this.querySelector('.js-submit-check')
      }

      onOptionChange() {
        const variant = this.getVariantFromOptions()

        if (this.submitButton) {
          this.submitButton.removeAttribute('disabled')
          this.submitButton.querySelector('span').innerHTML = 'Add'
        }

        if (this.submitCheckbox) {
          this.submitCheckbox.removeAttribute('disabled')
          this.querySelector('.js-submit-check-label').innerHTML = 'Add'
        }

        if (!variant) {
          if (this.submitButton) {
            this.submitButton.setAttribute('disabled', true)
            this.submitButton.querySelector('span').innerHTML = 'Unavailable'
          }

          if (this.submitCheckbox) {
            this.submitCheckbox.setAttribute('disabled', true)
            this.querySelector('.js-submit-check-label').innerHTML = 'Unavailable'
          }

          return
        }

        if (!variant.available) {
          if (this.submitCheckbox) {
            this.submitCheckbox.setAttribute('disabled', true)
            this.querySelector('.js-submit-check-label').innerHTML = 'Sold out'
          }

          if (this.submitButton) {
            this.submitButton.setAttribute('disabled', true)
            this.submitButton.querySelector('span').innerHTML = 'Sold out'
          }
        }

        this.updateMasterId(variant)
        this.updateMedia(variant)
        this.updatePrice(variant)
      }

      updateMasterId(variant) {
        this.querySelector('[name="id"]').value = variant.id
      }

      updateMedia(variant) {
        if (!variant.featured_image) return

        const src = Shopify.getImageWithSize(variant.featured_image.src, 150)

        this.querySelector('.js-product-card-image').setAttribute('src', src)
      }

      updatePrice(variant) {
        let priceHTML = `
          <span
            class="price price--end"
          >
            ${Shopify.formatPrice(variant.price)}
          </span>
        `
        if (!!variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceHTML = `
            <div class="product-card-alt__discounted-prices">
              <span class="visually-hidden">
                Regular price
              </span>
              <s class="product-card-alt__old-price price price--end">
                ${Shopify.formatPrice(variant.compare_at_price)}
              </s>
              <span class="visually-hidden">
                Sale price
              </span>
              <span class="price price--end">
              ${Shopify.formatPrice(variant.price)}
              </span>
            </div>
          `
        }

        this.querySelector('.js-price-wrapper').innerHTML = priceHTML
      }

      getVariantFromOptions() {
        const options = this.selectedOptionValues;
        return this.product.variants.find((variant) => {
          return variant['options'].every((value, index) => value === options[index]);
        });
      }

      get product() {
        return JSON.parse(this.querySelector('[data-product-json]').textContent)
      }

      get selectedOptionValues() {
        return Array.from(this.querySelectorAll('fieldset select, fieldset input:checked')).map(
          (option) => option.value
        );
      }
    })
}
